import { afterNextRender, Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  NavigationCancel,
  NavigationEnd,
  NavigationError,
  NavigationStart,
  Router,
  RouterOutlet,
} from '@angular/router';
import { UserState } from './features/account/services/user.state';
import { ProfilePromptState } from './features/account/services/profile-prompt.state';
import { KommoChat } from './core/services/kommo-chat';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private router = inject(Router);
  private userState = inject(UserState);
  private profilePromptState = inject(ProfilePromptState);
  private kommoChat = inject(KommoChat);

  loading = signal(false);
  navDone = signal(false);

  constructor() {
    this.router.events.pipe(takeUntilDestroyed()).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loading.set(true);
        this.navDone.set(false);
      }
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.navDone.set(true);
        setTimeout(() => this.loading.set(false), 300);
      }
    });

    afterNextRender(() => {
      this.kommoChat.start();
      this.userState
        .load()
        .subscribe(() => this.profilePromptState.maybeOpen());
    });
  }
}
